import { queryOptions, useQuery } from '@tanstack/react-query'
import { InferRequestType } from 'hono/client'

import { apiClient, formatClientResponse } from '@/apiClient.ts'

type FindDocumentAttributeValuesArgs = InferRequestType<
  (typeof apiClient.attributes)[':attributeId']['values']['$get']
>['param'] &
  InferRequestType<
    (typeof apiClient.attributes)[':attributeId']['values']['$get']
  >['query']

export const findDocumentAttributeValuesQueryOptions = (
  args: FindDocumentAttributeValuesArgs
) =>
  queryOptions({
    queryKey: ['document-attribute-values', args],
    queryFn: () =>
      apiClient.attributes[':attributeId'].values
        .$get({
          param: { attributeId: args.attributeId },
          query: { limit: args.limit, skip: args.skip, search: args.search },
        })
        .then((r) => formatClientResponse(r)),
  })

export const useFindAttributeValues = (
  args: FindDocumentAttributeValuesArgs,
  options?: Partial<ReturnType<typeof findDocumentAttributeValuesQueryOptions>>
) =>
  useQuery({
    ...findDocumentAttributeValuesQueryOptions(args),
    ...options,
  })
